import {
    getGroupList,
    getGroupDevs,
    getGroupAside,
    getNewApplied,
} from "@/api/index";
import router from "@/router";
import i18n from "@/lang/index";

const state = {
    GROUP_LIST: localStorage.getItem("groupList")
        ? JSON.parse(localStorage.getItem("groupList"))
        : [], // 团队信息
    SEARCH: "",
    CURRENT_GROUP: -1, // 当前设备分组id
    GROUP_DEVICE_LIST: [], // 团队所有设备
    ALL_DEVICE_GROUP: [], // 所有设备分组
    BATCH: [],
    ENTERPRISE_ID: null,
    HAS_ROLE_CHANGE: false, // 是否改变角色类型
    NEW_APPLICATIONS: 0, // 新的设备申请数
};
const mutations = {
    SET_GROUP_LIST: (state, data) => {
        state.GROUP_LIST = data;
        localStorage.setItem("groupList", JSON.stringify(state.GROUP_LIST));
    },
    DELETE_GROUP_LIST: (state) => {
        state.GROUP_LIST = [];
        localStorage.removeItem("groupList");
    },
    UPDATE_ENTERPRISE_ID: (state, value) => {
        state.ENTERPRISE_ID = value;
    },
    // 搜索
    UPDATE_SEARCH: (state, newTxt) => {
        state.SEARCH = newTxt;
    },
    // 设置当前设备分组
    SET_CURRENT_GROUP: (state, data) => {
        state.CURRENT_GROUP = data;
    },
    // 所有设备分组
    SET_ALL_DEVICE_GROUP: (state, data) => {
        state.ALL_DEVICE_GROUP = data;
    },
    // 修改设备分组
    UPDATE_DEVICE_GROUP: (state, updateData) => {
        console.log("updateData", updateData, "updateData");
        const list = state.ALL_DEVICE_GROUP.map((item) => {
            if (updateData.id === item.id) {
                item = {
                    ...item,
                    ...updateData,
                };
            }
            return item;
        });
        state.ALL_DEVICE_GROUP = list;
    },
    // 设备分组排序
    SORT_DEVICE_GROUP: (state, sortType) => {
        const partialGroup = state.ALL_DEVICE_GROUP.slice(1); // 去除未分组的设备分组列表
        partialGroup.sort((a, b) => {
            let type = 0;

            // 根据排序类型来调整排序规则
            if (sortType === "time-desc") {
                // 按 creationTime 降序排序
                type = b.creationTime - a.creationTime;
            } else if (sortType === "name-asc") {
                // 按 name 升序排序
                type = a.name.localeCompare(b.name);
            } else if (sortType === "name-desc") {
                // 按 name 降序排序
                type = b.name.localeCompare(a.name);
            } else {
                // 默认按 creationTime 升序排序
                type = a.creationTime - b.creationTime;
            }

            return type;
        });
        state.ALL_DEVICE_GROUP = state.ALL_DEVICE_GROUP.slice(0, 1).concat(
            partialGroup
        );
        console.log(state.ALL_DEVICE_GROUP, "我最牛啊");
    },
    // 获取所有设备列表
    GET_DEVICE_LIST: (state, data) => {
        state.GROUP_DEVICE_LIST = data;
    },
    // 修改设备列表信息
    UPDATE_DEVICE_LIST: (state, updateData) => {
        const list = state.GROUP_DEVICE_LIST.map((item) => {
            if (updateData.deviceID === item.deviceID) {
                item = {
                    ...item,
                    ...updateData,
                };
            }
            return item;
        });
        state.GROUP_DEVICE_LIST = list;
    },
    DELECT_DEVICE_LIST: (state, delect) => {
        console.log(delect, "store delet");
        // 设备列表修改
        const newDevices = state.GROUP_DEVICE_LIST.filter(
            (item) =>
                !delect.some(
                    (deletedItem) => deletedItem.deviceID === item.deviceID
                )
        );
        state.GROUP_DEVICE_LIST = newDevices;

        // 分组修改
        const allGroup = state.ALL_DEVICE_GROUP;
        allGroup.forEach((groupItem) => {
            delect.forEach((delectItem) => {
                delectItem.folderID === groupItem.id && (groupItem.devs -= 1);
            });
        });
        state.ALL_DEVICE_GROUP = allGroup;
    },
    //更新表格批量选择数据
    UPDATE_BATCH: (state, listData) => {
        state.BATCH = listData;
    },
    UPDATE_ROLE_TYPE: (state, isChange) => {
        state.HAS_ROLE_CHANGE = isChange;
    },
    // 更新新的设备申请数
    UPDATE_NEW_APPLICATION: (state, data) => {
        state.NEW_APPLICATIONS = data;
    },
};
const actions = {
    async setGroupList({ commit }) {
        const res = await getGroupList();
        if (res.code === 200) {
            commit("SET_GROUP_LIST", res.data);
            res.data.length > 0 &&
                res.data[0].enterpriseID &&
                commit("ENTERPRISE_ID", res.data[0].enterpriseID);
        }
    },
    async getGroupDeviceList({ commit, state }) {
        const request = {
            offset: 0,
            rows: 4294967294,
            enterpriseID: Number(router.currentRoute.params.companyName),
        };
        const res = await getGroupDevs(request);
        commit("GET_DEVICE_LIST", res.data);
    },
    // 获取设备分组
    async getAsideList({ commit }) {
        const request = {
            enterpriseID: Number(router.currentRoute.params.companyName),
        };
        const res = await getGroupAside(request);
        if (res.code === 200) {
            // 处理数据
            let asideList = res.data;
            //   // 计算所有分组的devs总和
            //   const totalDevs = asideList.reduce((sum, cur) => sum + cur.devs, 0);

            // 给每个对象添加isEdit: false, operate: true; 默认分组(id=0)operate是false
            const withFlags = asideList.map((obj) => {
                if (obj.id === 0) {
                    obj.name = i18n.t("deploy.unGrp");
                }
                return {
                    ...obj,
                    isEdit: false,
                    operate: obj.id !== 0,
                };
            });

            // 时间升序排列
            withFlags.sort((a, b) => {
                return a.creationTime - b.creationTime;
            });

            // 将name为空的对象的name改为"未分组"，operate改为false
            withFlags.sort((a, b) => {
                if (a.name === i18n.t("deploy.unGrp")) {
                    return -1;
                } else if (b.name === i18n.t("deploy.unGrp")) {
                    return 1;
                } else {
                    return 0;
                }
            });
            commit("SET_ALL_DEVICE_GROUP", withFlags);
        }
    },
    async getNewApplication({ commit, state }, value) {
        // alert("1");
        console.log(state.GROUP_LIST, "fsdafsafdsafadf===");
        if (!state.GROUP_LIST.length) {
            return false;
        }
        const params = {
            enterpriseID:
                state.GROUP_LIST[0] && state.GROUP_LIST[0].enterpriseID,
        };
        console.log(state.GROUP_LIST[0], "getNewApplication_value");
        const res = await getNewApplied(params);
        console.log(res, "设备数量法撒旦地方撒");
        if (res.code === 200) {
            // res.devCount
            commit("UPDATE_NEW_APPLICATION", value ? value : res.devCount);
            res.devCount
                ? document.getElementById("apply-dot")?.classList.add("show")
                : document
                      .getElementById("apply-dot")
                      ?.classList.remove("show");
        }
    },
};
const getters = {
    // 设备管理/设备列表 =》 侧边导航
    asideList: (sate) => {
        let asideList = sate.ALL_DEVICE_GROUP;
        console.log(asideList, "asideList");
        // 计算所有分组的devs总和
        const totalDevs = asideList.reduce((sum, cur) => sum + cur.devs, 0);
        const totalGroup = {
            id: -1, // id为-1表示为总的分组
            parentID: null,
            devs: totalDevs,
            name: i18n.t("devMgmt.allGrp"),
            isEdit: false,
            operate: false,
        };
        asideList = [totalGroup, ...asideList];
        // 找到devs为0的对象并删除
        // const filtered = asideList.filter((obj) => obj.devs !== 0);
        return asideList;
    },
    // 当前分组的所有设备
    deviceTable: (state) => {
        let list = state.GROUP_DEVICE_LIST;
        const currentGroupId = state.CURRENT_GROUP;
        if (currentGroupId !== -1) {
            list = state.GROUP_DEVICE_LIST.filter((item) => {
                return item.folderID === currentGroupId;
            });
        }
        list = list.filter((item) => {
            return (
                item.nickName.indexOf(state.SEARCH) > -1 ||
                item.deviceID.toString().indexOf(state.SEARCH) > -1 ||
                item.memo.indexOf(state.SEARCH) > -1
            );
        });
        return list;
    },
    currentGroudInfo: (state) => {
        const data = state.GROUP_LIST.filter((item) => {
            console.log(state.ENTERPRISE_ID, "state.ENTERPRISE_ID f");
            return item.enterpriseID === state.ENTERPRISE_ID;
        });
        return data[0];
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
